// НОВАЯ ВЕРСИЯ САЙТА В ПРИЛОЖЕНИИ — ПЕРЕЗАПУСК РЕШАЕТ ОБОЛОЧКА (ТЗ релиза П3, 29.09.2026).
//
// Чистая логика без window: pwa-updater.tsx зовёт её с настоящим мостом, тесты — с
// поддельным. Правило одно: в приложении с методом моста `updateReady` сайт отдаёт
// перезапуск оболочке и сам НЕ перезагружается; метода нет, мост отказал или ответ без
// `handled: true` — прежняя перезагрузка страницы. Браузер метода не имеет никогда.

export interface UpdateHandoffOpts {
  from: string;
  to: string;
  urgent?: boolean;
}

export interface UpdateBridgePort {
  /** Есть ли метод в ЭТОЙ сборке (только nativeMethod('updateReady')). */
  has: boolean;
  call?: (opts: UpdateHandoffOpts) => Promise<{ handled?: boolean } | undefined | void>;
}

export type UpdateAction = 'native' | 'reload';

/** Кто перезапускает: оболочка (метод есть) или сама страница. */
export function pickUpdateAction(port: UpdateBridgePort | null): UpdateAction {
  return port?.has && typeof port.call === 'function' ? 'native' : 'reload';
}

/**
 * Отдать перезапуск оболочке. true — оболочка ответила `handled: true`, страница НЕ
 * перезагружается; false — перезагружаться самим (прежнее поведение).
 */
export async function handOffUpdate(port: UpdateBridgePort | null, opts: UpdateHandoffOpts): Promise<boolean> {
  if (pickUpdateAction(port) !== 'native') return false;
  try {
    const r = await port!.call!(opts);
    return r?.handled === true;
  } catch {
    return false;
  }
}

/** Журнал страницы при сворачивании приложения — не чаще раза в 60 с. */
export const HIDE_JOURNAL_GAP_MS = 60_000;

export function hideJournalAllowed(lastAt: number, now: number, gapMs = HIDE_JOURNAL_GAP_MS): boolean {
  if (!Number.isFinite(lastAt) || lastAt <= 0) return true;
  if (lastAt > now) return false;
  return now - lastAt >= gapMs;
}
